import Banner from '../components/layout/Banner';
import Footer from '../components/layout/Footer';

import BackgroundImage from '../assets/images/fotos.jpg';
import AlbumsGrid from '../components/layout/fotos/AlbumsGrid';

export default function Fotos() {
    return (
        <>
            <Banner title={'Foto\'s'} image={BackgroundImage} />
            <AlbumsGrid apiUrl="/api/v1/albums" excludeSlugs={[]}/>
            <Footer />
        </>
    );
}